module.exports = __webpack_public_path__ + "img/search-in-content.144b2134.svg";